import {Company, DateTime, IdCard, PhoneNumber, TerminalLocation} from "@/modules/models";
import {noNullApply, requireNum, requireStr} from "@/modules/utils";

export class CardExpirationReportRow {
    constructor(public cardNum: number, public personGuid: string, public firstName: string, public lastName: string, public phone: PhoneNumber | null,
                public expirationDate: DateTime, public lastTimeIn: DateTime, public terminalLocation: TerminalLocation,
                public cardCompany: Company,
    ) {}

    static fromJson(json: any): CardExpirationReportRow {
        return new CardExpirationReportRow(
            requireNum(json.cardNum),
            requireStr(json.personGuid),
            requireStr(json.firstName),
            requireStr(json.lastName),
            noNullApply(json.phone, PhoneNumber.fromJson),
            DateTime.fromJson(json.expirationDate),
            DateTime.fromJson(json.lastTimeIn),
            TerminalLocation.fromJson(json.terminalLocation),
            Company.fromJson(json.cardCompany),
        );
    }
}